<!-- 申请意向的学校 -->
<template>
  <div class="choose-intention">
    <div class="choose-intention-con">
      <p class="choose-intention-title">申请意向 - 学校列表</p>
      <div class="choose-intention-table">
        <Table :columns="schoolColumnsData"
               :data="intentionList"
               :border=true></Table>
      </div>
      <div class="choose-intention-pageWrap">
        <Page :total="totalItems"
              :page-size="pageSize"
              :current="currentPage"
              @on-change="handlePageChange"
              @on-page-size-change="handlePageSizeChange"></Page>
      </div>
    </div>
    <!-- 备注 -->
    <intention-remark ref="remark"
                      :detail="schoolDetail"
                      @on-change="getPageList"
                      :hasFeedback="hasFeedback"></intention-remark>
  </div>
</template>
<script>
// components
import IntentionRemark from './intention-remark'
// api
import { getPreviewItemPurposeList, getSchemeItemPurposeList, getItemPurposeModify } from '@/api/preproject'
// mixins
import mixinsPage from '@/view/mixins/page'
import isAllowEdit from '@/view/mixins/is-edit'
export default {
  name: '',
  mixins: [mixinsPage, isAllowEdit],
  props: ['tabColumns', 'hasFeedback', 'type'],
  components: {
    IntentionRemark
  },
  data () {
    return {
      id: this.$route.query.id,
      schoolColumnsData: [
        {
          title: '-',
          key: 'a',
          align: 'center'
        },
        {
          title: '意向操作',
          key: 'univer',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let isIntention = params.row.purpose
            if (isIntention !== 'YES') {
              return h('span', '--')
            }
            return h('span', {
              style: {
                color: '#ffa940',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  console.log(111111111, this.isallowedit)
                  if (this.isallowedit) {
                    this.handleIntention(params.row.id, isIntention)
                  } else {
                    this.noPermission()
                  }
                }
              }
            }, '删除')
          }
        },
        {
          title: '意向反馈',
          key: 'univer',
          align: 'center',
          fixed: 'right',
          width: 100,
          render: (h, params) => {
            return h('div', {
              style: {
                color: '#6589dd',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  if (this.isallowedit) {
                    this.schoolDetail = params.row
                    this.$refs['remark'].handleShow()
                  } else {
                    this.noPermission()
                  }
                }
              }
            }, '反馈')
          }
        }
      ],
      intentionList: [],
      schoolDetail: ''
    }
  },
  computed: {},
  mounted () {
    this.getPageList()
  },
  methods: {
    getPageList () {
      let params = {
        sourceId: this.id,
        currentPage: this.currentPage - 1,
        pageSize: this.pageSize
      }
      this.getListType(params).then(res => {
        this.intentionList = res.data.page.result
        this.totalItems = res.data.page.totalItems
      }).catch(() => {
        this.intentionList = []
        this.currentPage = 1
        this.totalItems = 0
      })
    },
    getListType (params) {
      return new Promise((resolve, reject) => {
        if (this.type === 'preview') {
          getPreviewItemPurposeList(params).then(res => {
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        }
        if (this.type === 'scheme') {
          getSchemeItemPurposeList(params).then(res => {
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    // 点击申请意向
    handleIntention (id, isIntention) {
      getItemPurposeModify({
        id,
        purpose: isIntention === 'YES' ? 'NO' : 'YES'
      }).then(res => {
        // 判断删除操作导致的currentPage改变
        if (this.totalItems - 1 <= (this.currentPage - 1) * this.pageSize) {
          this.currentPage = this.currentPage - 1 <= 1 ? 1 : this.currentPage - 1
        }
        this.getPageList()
        this.$emit('on-change')
      }).catch((error) => {
        this.$Message.error(error.message)
      })
    }
  },
  watch: {
    tabColumns: {
      handler (newValue) {
        this.schoolColumnsData.splice(0, 0, ...newValue)
      },
      immediate: true
    },
    hasFeedback: {
      handler (newValue) {
        if (newValue) {
          this.schoolColumnsData.splice(this.schoolColumnsData.length - 2, 1)
        }
      }
    }
  }
}
</script>
<style lang='less' scoped>
</style>
